
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenantId]/games/[gameId]/live/results",
      function () {
        return require("private-next-pages/[tenantId]/games/[gameId]/live/results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenantId]/games/[gameId]/live/results"])
      });
    }
  